export const createStyles = (theme: any) => ({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    width: '100%',
    minWidth: 0,
    gap: { xs: 1, md: 1.25 },
  },
  avatar: {
    width: 40,
    height: 40,
    flexShrink: 0,
  },
  editorCard: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    boxSizing: 'border-box',
    minWidth: 0,
    gap: 0,
    px: { xs: 1, md: 1.5 },
    py: '3px',
    overflow: 'hidden',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 1,
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    fontFamily: theme.typography.fontFamily,
    '& *': {
      maxWidth: '100%',
      fontFamily: `${theme.typography.fontFamily} !important`,
    },
    '& [role="toolbar"]': {
      flexWrap: 'wrap',
    },
    '& [role="textbox"]': {
      minHeight: '36px',
      fontFamily: theme.typography.fontFamily,
    },
    '&[data-expanded="false"] [role="textbox"]': {
      height: '36px',
      maxHeight: '36px',
      overflow: 'hidden',
    },
    '&[data-expanded="false"] [role="textbox"] p': {
      marginTop: '8px',
      marginBottom: '4px',
    },
    '&[data-expanded="false"] [data-testid="spacer"]': {
      display: 'none',
    },
    '&[data-expanded="true"]': {
      gap: 1.5,
      py: 1.5,
    },
    '&[data-expanded="true"] [role="textbox"]': {
      minHeight: '72px',
      transition: 'min-height 160ms ease-out',
    },
    '& [data-testid="code-block"] *': {
      fontFamily: 'monospace !important',
    },
    '& .katex, & .katex *': {
      fontFamily: 'KaTeX_Main, serif !important',
    },
    '&:focus-within': {
      borderColor: theme.palette.primary.main,
      boxShadow: `0 0 0 1px ${theme.palette.primary.main}`,
    },
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    flexWrap: 'wrap',
    gap: 1,
  },
  actionButton: {
    minWidth: 80,
    textTransform: 'none',
    fontFamily: theme.typography.fontFamily,
    fontWeight: theme.typography.fontWeightMedium,
    '&:focus-visible': {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: 2,
    },
  },
});
